<template>
  <div>
    <Header />
    <slot />
    <Footer />
  </div>
</template>

<style src="@/assets/css/common.css"></style>
<script>
import Header from "@/components/layout/applicant/Header.vue";
import Footer from "@/components/layout/applicant/Footer.vue";
import $ from "jquery";
import { mapGetters } from "vuex";
import store from "@/store";
import axios from "axios";

export default {
  name: "MainLayout",
  components: {
    Header,
    Footer
  },

  computed: {
    ...mapGetters({ isApplicantLoggedIn: "isApplicantLoggedIn", applicantId: "applicantId", applicantToken: "applicantToken", resumeCountNo: "resumeCountNo" })
  },

  methods: {
    getResumeCount() {
      axios.get("/applicant/resume/count/" + this.applicantId)
        .then(response => {
          this.resumeCount = response.data.count;
          store.commit("setResumeCount", this.resumeCount);
        })
        .catch(error => {
          console.log("Resume Count API error:::::>", error.response.data);
        });
    },

    goResumeRegister() {
      if (this.resumeCountNo < 3) {
        this.$router.push('/resume', () => { });
      } else {
        this.$notification.error("အလုပ်လျှောက်လွှာအများဆုံး ၃ ခုသာ ပြုလုပ်ခွင့်ပြုသည်။", { timer: 3, position: 'bottomCenter' });
      }
    },

    setupAnimationObserver() {
      const targetSection = document.querySelector('.footer-cta-section');
      const mockupContainer = document.querySelector('.cta-mockup-col');

      if (targetSection && mockupContainer) {
        mockupContainer.classList.remove('start-animation');

        const observerOptions = {
          root: null,
          rootMargin: "0px 0px -40% 0px",
          threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              mockupContainer.classList.add('start-animation');
              observer.unobserve(entry.target);
            }
          });
        }, observerOptions);

        observer.observe(targetSection);
      }
    },

  },

  mounted() {
    if (this.applicantId) {
      this.getResumeCount();
    }

    $(document).ready(function () {
      // $(window).scroll(function() {
      //   var top = $(window).scrollTop();
      //   if (top == 0) {
      //     $("#page_top").css("display", "none");
      //     $("header").removeClass("add_bg");
      //   } else {
      //     $("#page_top").css("display", "block");
      //     $("header").addClass("add_bg");
      //   }
      // });

      // $(window).scroll(function() {
      //   var menuHeight = $(".logo_sec").height();
      //   if ($(this).scrollTop() >= menuHeight) {
      //     $("header").addClass("add_bg");
      //   } else {
      //     $("header").removeClass("add_bg");
      //   }
      // });
    });

    $(document).ready(function () {
      $(window)
        .resize(function () {
          var windowWidth = $(window).width();
          if (windowWidth < 768) {
            $("#menu_btn").click(function () {
              $(".hide_menu").toggle();
              if ($(this).hasClass("menu_active")) {
                $(this).removeClass("menu_active");
              } else {
                $(this).addClass("menu_active");
              }
            });
            $(".dropdown a").click(function () {
              $(this)
                .next("ul")
                .toggle();
              if (
                $(this)
                  .parent()
                  .hasClass("active")
              ) {
                $(this)
                  .parent()
                  .removeClass("active");
              } else {
                $(this)
                  .parent()
                  .addClass("active");
              }
            });
          } else {
            $("#menu_btn").unbind();
            $(".dropdown a").unbind();
          }
        })
        .resize();
    });

    this.setupAnimationObserver();
  }
};
</script>
